module.exports = __webpack_public_path__ + "img/base_restauration_confiserie.d579f7bf.svg";